import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, ArrowLeft, QrCode, Bell, Users, Smartphone, Mail, CheckCircle, Clock, UserPlus, FileText, BarChart3 } from 'lucide-react';

import Navbar from '../components/Navbar';

const ComoFunciona = () => {
  const navigate = useNavigate();

  const passos = [
    {
      numero: '01',
      titulo: 'Crie sua conta grátis',
      descricao: 'Cadastre-se em menos de 2 minutos. Sem cartão de crédito, sem compromisso.',
      icon: UserPlus,
      cor: 'bg-blue-100 text-blue-600',
    },
    {
      numero: '02',
      titulo: 'Configure seus serviços',
      descricao: 'Defina os tipos de serviços que você oferece e os prazos de renovação.',
      icon: FileText,
      cor: 'bg-purple-100 text-purple-600',
    },
    {
      numero: '03',
      titulo: 'Imprima seu QR Code',
      descricao: 'Coloque em local visível para que seus clientes escaneiem e se cadastrem.',
      icon: QrCode,
      cor: 'bg-orange-100 text-orange-600',
    },
    {
      numero: '04',
      titulo: 'Relaxe e deixe o Lembrou? trabalhar',
      descricao: 'O sistema envia lembretes automáticos nos dias certos. Você só acompanha.',
      icon: Bell,
      cor: 'bg-green-100 text-green-600',
    },
  ];

  const fluxoCliente = [
    { icon: QrCode, texto: 'Cliente escaneia o QR Code', tempo: '' },
    { icon: UserPlus, texto: 'Preenche nome, email ou telefone', tempo: '30 segundos' },
    { icon: CheckCircle, texto: 'Cadastro confirmado automaticamente', tempo: '' },
    { icon: Bell, texto: 'Recebe lembretes D-30, D-15, D-7 e D-0', tempo: 'Automático' },
  ];

  return (
    <div className="min-h-screen bg-white">
	{/* ============================================================
           PASSO 2 — Substitua qualquer <nav> antiga por este componente
           Basta colocar <Navbar /> no topo de cada página.
           O link ativo é detectado automaticamente pela URL.
          ============================================================ */}
      <Navbar />
	  
      {/* ===== NAVBAR ===== */}
     

      {/* ===== HERO ===== */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-red-50/30 to-white py-16 lg:py-24">
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl -z-10" />
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
         

          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block bg-primary/10 text-primary text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              Como Funciona
            </span>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Simples assim: <span className="text-primary">4 passos</span> para nunca mais esquecer
            </h1>
            <p className="text-lg text-gray-500 leading-relaxed">
              O Lembrou? foi feito para ser simples. <br />Configure uma vez e deixe a automação trabalhar por você.
            </p>
          </div>
        </div>
      </section>

      {/* ===== PASSOS ===== */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {passos.map((passo, index) => (
              <div key={index} className="relative">
                {/* Linha conectora */}
                {index < passos.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-gray-200 -z-10" style={{ width: 'calc(100% - 2rem)' }} />
                )}
                
                <div className="bg-gray-50 rounded-2xl p-6 hover:bg-white hover:shadow-lg transition-all border border-transparent hover:border-gray-100">
                  <div className={`w-14 h-14 rounded-2xl ${passo.cor} flex items-center justify-center mb-4`}>
                    <passo.icon className="w-7 h-7" />
                  </div>
                  <div className="text-4xl font-extrabold text-gray-200 mb-2">{passo.numero}</div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{passo.titulo}</h3>
                  <p className="text-sm text-gray-500">{passo.descricao}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FLUXO DO QR CODE ===== */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-block bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-4">
                QR Code Inteligente
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                Seu cliente se cadastra em segundos
              </h2>
              <p className="text-gray-500 mb-8 leading-relaxed">
                Imprima seu QR Code exclusivo e coloque em local visível. Quando o cliente escaneia, 
                ele é direcionado para uma página simples onde preenche seus dados em segundos.
              </p>

              <div className="space-y-4">
                {fluxoCliente.map((item, index) => (
                  <div key={index} className="flex items-center gap-4 bg-white rounded-xl p-4 border border-gray-100">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <item.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-gray-900">{item.texto}</p>
                      {item.tempo && (
                        <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
                          <Clock className="w-3 h-3" />
                          {item.tempo}
                        </p>
                      )}
                    </div>
                    {index < fluxoCliente.length - 1 && (
                      <ArrowRight className="w-5 h-5 text-gray-300" />
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img src="/Upload-lembrou.svg" alt="QR Code Flow" className="w-full h-auto max-w-md mx-auto" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== NOTIFICAÇÕES ===== */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 relative">
              {/* Ilustração de notificações */}
              <div className="relative max-w-sm mx-auto">
                <div className="bg-gray-100 rounded-3xl p-8">
                  <div className="space-y-4">
				    {/* D-30 */}
                    <div className="bg-yellow-50 rounded-xl p-4 border-l-4 border-yellow-400 transform -rotate-1">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
                          <Bell className="w-5 h-5 text-yellow-600" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">30 dias antes</p>
                          <p className="text-xs text-gray-500">Primeiro lembrete enviado</p>
                        </div>
                      </div>
                    </div>
                    {/* D-15 */}
                    <div className="bg-yellow-50 rounded-xl p-4 border-l-4 border-yellow-400 transform -rotate-1">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
                          <Bell className="w-5 h-5 text-yellow-600" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">15 dias antes</p>
                          <p className="text-xs text-gray-500">Segundo lembrete enviado</p>
                        </div>
                      </div>
                    </div>

                    {/* D-7 */}
                    <div className="bg-orange-50 rounded-xl p-4 border-l-4 border-orange-400 transform rotate-1">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
                          <Bell className="w-5 h-5 text-orange-600" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">7 dias antes</p>
                          <p className="text-xs text-gray-500">Terceiro lembrete enviado</p>
                        </div>
                      </div>
                    </div>

                    {/* D-0 */}
                    <div className="bg-red-50 rounded-xl p-4 border-l-4 border-red-400 transform -rotate-1">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                          <Bell className="w-5 h-5 text-red-600" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">No dia do vencimento</p>
                          <p className="text-xs text-gray-500">Último aviso enviado</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <span className="inline-block bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-4">
                Alertas Automáticos
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                Lembretes no momento certo
              </h2>
              <p className="text-gray-500 mb-8 leading-relaxed">
                O Lembrou? envia notificações automáticas em três momentos estratégicos: 
                30 dias, 15 dias, 7 dias e no dia do vencimento. Seu cliente nunca esquece.
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-blue-50 rounded-xl p-4 text-center">
                  <Mail className="w-8 h-8 text-blue-600 mx-auto mb-2" />
                  <p className="font-semibold text-gray-900 text-sm">Email</p>
                  <p className="text-xs text-gray-500">Plano Essencial</p>
                </div>
                <div className="bg-green-50 rounded-xl p-4 text-center">
                  <Smartphone className="w-8 h-8 text-green-600 mx-auto mb-2" />
                  <p className="font-semibold text-gray-900 text-sm">WhatsApp</p>
                  <p className="text-xs text-gray-500">Plano Profissional</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PAINEL ===== */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-4">
              Painel de Controle
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Tudo em um só lugar
            </h2>
            <p className="text-gray-500 max-w-2xl mx-auto">
              Acompanhe todos os seus clientes, vencimentos e status de notificações em um painel simples e intuitivo.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Users, title: 'Gestão de Clientes', desc: 'Veja todos os seus clientes cadastrados e seus serviços' },
              { icon: BarChart3, title: 'Estatísticas', desc: 'Acompanhe vencimentos próximos e taxa de renovação' },
              { icon: Bell, title: 'Histórico de Alertas', desc: 'Veja todos os lembretes enviados e seus status' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Pronto para começar?
          </h2>
          <p className="text-white/80 mb-8 text-lg">
            Configure em menos de 5 minutos e comece a receber cadastros hoje mesmo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/auth?mode=business')}
              className="rounded-full bg-white text-primary hover:bg-gray-100 px-8 py-6 text-base font-semibold shadow-lg"
            >
              Criar Conta Grátis
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Link to="/planos">
              <Button
                variant="outline"
                className="rounded-full border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-base font-semibold"
              >
                Ver Planos
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-10">
            <div>
              <img src="/lembrou-logo-png.png" alt="Lembrou?" className="h-8 mb-4 brightness-0 invert" />
              <p className="text-sm text-gray-400">
                2026 © Lembrou.com.br
                <br />Todos os direitos reservados.
              </p>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Central do Corretor</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><button onClick={() => navigate('/auth?mode=business')} className="hover:text-white transition-colors">Cadastre-se</button></li>
                <li><button onClick={() => navigate('/auth?mode=business')} className="hover:text-white transition-colors">Login</button></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Institucional</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/sobre" className="hover:text-white transition-colors">Sobre o Lembrou?</Link></li>
                <li><Link to="/planos" className="hover:text-white transition-colors">Planos e Preços</Link></li>
                <li><Link to="/como-funciona" className="hover:text-white transition-colors">Como Funciona</Link></li>
                <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Usuário</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><button onClick={() => navigate('/timeline')} className="hover:text-white transition-colors">Minha Timeline</button></li>
                <li><button onClick={() => navigate('/auth?mode=user')} className="hover:text-white transition-colors">Criar Conta Gratuita</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <span className="text-xs text-gray-600">© 2026 Lembrou — Todos os direitos reservados</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ComoFunciona;
